import { indexOf, filter, castArray, cloneDeep } from 'lodash';
import React from 'react';

// import default view
import { drugIntakeSelection as DrugIntakeSelectionView } from './drugIntakeSelection.view';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { drugIntakeSelection, DrugIntakeSelection } from 'modules/drugIntakeSelection';
 *
 * // create a component
 * const ComponentWithHOC = drugIntakeSelection( CustomView );
 */
export  class DrugIntakeSelection extends React.Component {
    constructor( props ) {
        super( props );

        this.state = this.composeDataFromProps( this.props );

        //bind
        this.handleFormSubmit = this.handleFormSubmit.bind( this );
        this.handleClearSelection = this.handleClearSelection.bind( this );
    }

    composeDataFromProps( props ) {
        log.debug( 'DrugIntakeSelection.composeDataFromProps()' );
        log.debug( props );

        const { subFields, config, optionsList } = props;

        const fields = filter( subFields, field => {
            return -1 !== indexOf( config.subFields, field.name );
        } );

        return {
            options: optionsList,
            fields
        };
    
    }
    
    handleFormSubmit( values ) {
        log.debug( 'DrugIntakeSelection.handleFormSubmit()' );

        this.props.onChange( {
            name: this.props.name,
            value: [ ...this.props.value, ...castArray( values ) ]
        } );
    }

    handleClearSelection( index ) {
        log.debug( 'DrugIntakeSelection.handleClearSelection()' );

        const newlist = filter( cloneDeep( this.props.value ), ( val, _index ) => {
            return _index !== index;
        } );

        this.props.onChange( {
            name: this.props.name,
            value: newlist
        } );
    }

    render() {
        return (
            <DrugIntakeSelectionView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.handleFormSubmit }
                clearSelection={ this.handleClearSelection }
            />
        );
    }
}

// set display name
DrugIntakeSelection.displayName = 'DrugIntakeSelection';

// default props
DrugIntakeSelection.defaultProps = {
    actions: [
        {
            name: 'add',
            title: {
                refId: 'displayTextAdd'
            }
        }
    ]
};

// prop types
DrugIntakeSelection.propTypes = {};


